/**
 * window.Cypress appears to be unreliabley set, everywhere we currently check for Cypress, we have the user email so we can also regex match the email to not send
 */
export function isCypressUserEmail(email: string | undefined | null) {
  if (window.Cypress) return true;
  return !!email?.match(/cypress\+[\w.-]+@apollographql\.com/);
}

/**
 * Detects if we're running in a Cypress test environment.
 * Uses multiple detection methods since Cypress injection timing varies.
 * Use this when you don't have user email context.
 */
export function isCypressEnvironment(): boolean {
  // Method 1: URL-based detection (most reliable early detection)
  const hostname = window.location.hostname;
  const port = window.location.port;
  const cypressUrls = [
    'studio.local.apollographql.com', // Main Cypress test domain
    'local-studio.apollographql.com', // Cypress PROD environment
  ];
  const isEmbeddedTest =
    hostname === 'localhost' && (port === '8080' || port === '9090');

  // Method 2: Browser-based detection
  const browserIndicators =
    'Cypress' in window ||
    !!window.navigator.webdriver ||
    window.navigator.userAgent.includes('Cypress') ||
    document.documentElement.hasAttribute('data-cy');

  return cypressUrls.includes(hostname) || isEmbeddedTest || browserIndicators;
}
